import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
// import { xsollaProducts, PAicon } from "./PAsolutionsMenu";
import { xsollaProducts } from "../../data/xsollaProducts";


export function PAicon ({
  product = 'store',
  width = '44',
  height = '44',
  color = 'inherit',
}) {
  if (xsollaProducts[product]) {return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        color: color }}
      dangerouslySetInnerHTML={{
        __html:
          xsollaProducts[product]["icon"]
        }}
    />
  )} else {
    return null;
  }
}
